export default {
  navItems: [
    {
      name: 'Dashboard',
      url: '/dashboard',
      icon: 'icon-speedometer',
      permissionRequired: null
    },
    {
      name: 'Clients',
      url: '/manage/clients',
      icon: 'fa fa-address-book-o',
      permissionRequired: 'pm.warehouses.items.view',
      children: [
        {
          name: 'Manage',
          url: '/manage/clients',
          icon: 'fa fa-angle-right',
          permissionRequired: 'pm.clients.view',
        },
        {
          name: 'Items',
          url: '/manage/clients/items',
          icon: 'fa fa-angle-right',
          permissionRequired: 'pm.warehouses.items.view'
        },
        {
          name: 'Item Groups',
          url: '/warehouses/item-groups',
          icon: 'fa fa-angle-right',
          permissionRequired: 'pm.warehouses.productGroups.view'
        },
        {
          name: 'Rate Shops',
          url: '/manage/rate-shops',
          icon: 'fa fa-angle-right',
          permissionRequired: 'pm.other.storefrontRateShops'
        }
      ]
    },
    {
      name: 'Storefronts',
      url: '/storefronts',
      icon: 'fa fa-shopping-bag',
      permissionRequired: 'pm.storefronts.view',
      children: [
        {
          name: 'Manage',
          url: '/storefronts/manage',
          icon: 'fa fa-angle-right',
          permissionRequired: 'pm.storefronts.view',
        },
        {
          name: 'ShipCode Mappings',
          url: '/storefronts/shipcode-mappings',
          icon: 'fa fa-angle-right',
          permissionRequired: 'pm.other.shipCodeMappings'
        },
        {
          name: 'Order Tags',
          url: '/storefronts/order-tags',
          icon: 'fa fa-angle-right',
          permissionRequired: 'pm.storefront.orderTags.view'
        },
        {
          name: 'Products',
          url: '/storefronts/products',
          icon: 'fa fa-angle-right',
          permissionRequired: 'pm.storefront.products.view'
        },
        {
          name: 'Product Mappings',
          url: '/storefronts/product-mappings',
          icon: 'fa fa-angle-right',
          permissionRequired: 'pm.storefront.products.canMap'
        },
        {
          name: 'Shipments',
          url: '/storefronts/shipments',
          icon: 'fa fa-angle-right',
          permissionRequired: 'pm.orders.view'
        },
        {
          name: 'Products Groups',
          url: '/storefronts/product-groups',
          icon: 'fa fa-angle-right',
          permissionRequired: 'pm.storefront.products.view'
        },
        {
          name: 'Order Groups',
          url: '/storefronts/order-groups',
          icon: 'fa fa-angle-right',
          permissionRequired: 'pm.storefront.orderGroups.view'
        },
        {
          name: 'Order Returns',
          url: '/storefronts/order-returns',
          icon: 'fa fa-angle-right',
          permissionRequired: 'pm.orders.view'
        }
      ]
    },
    {
      name: 'Storefront Orders',
      url: '/orders',
      icon: 'icon-list',
      permissionRequired: 'pm.orders.view',
      children: [
        {
          name: 'To Review',
          url: '/orders?orderStatus=on_hold',
          icon: 'fa fa-lightbulb-o',
          permissionRequired: 'pm.orders.view',
          children: [
            {
              name: 'No Inventory',
              url: '/orders?orderStatus=on_hold&onHoldReason=Not Enough Inventory',
              icon: 'fa fa-angle-right',
              permissionRequired: 'pm.orders.view'
            },
            {
              name: 'Address Validation',
              url: '/orders?orderStatus=on_hold&onHoldReason=Address Validation',
              icon: 'fa fa-angle-right',
              permissionRequired: 'pm.orders.view'
            },
            {
              name: 'WMS Errors',
              url: '/orders?orderStatus=on_hold&onHoldReason=Warehouse Error',
              icon: 'fa fa-angle-right',
              permissionRequired: 'pm.orders.view'
            },
            {
              name: 'Unknown SKU',
              url: '/orders?orderStatus=on_hold&onHoldReason=SKU Not Configured',
              icon: 'fa fa-angle-right',
              permissionRequired: 'pm.orders.view'
            },
            {
              name: 'ShipCode Error',
              url: '/orders?orderStatus=on_hold&onHoldReason=ShipCode Not Configured',
              icon: 'fa fa-angle-right',
              permissionRequired: 'pm.orders.view'
            },
            {
              name: 'Other',
              url: '/orders?orderStatus=on_hold&onHoldReason=Review Needed',
              icon: 'fa fa-angle-right',
              permissionRequired: 'pm.orders.view'
            },
            {
              name: 'To Split',
              url: '/orders/split-recs',
              icon: 'fa fa-info',
              permissionRequired: 'pm.orders.view'
            },
            {
              name: 'Has Inventory',
              url: '/orders/unhold-recs',
              icon: 'fa fa-info',
              permissionRequired: 'pm.orders.view'
            }
          ]
        },
        {
          name: 'All',
          url: '/orders',
          icon: 'fa fa-angle-right',
          permissionRequired: 'pm.orders.view'
        },
        {
          name: 'Awaiting Payment',
          url: '/orders?orderStatus=awaiting_payment',
          icon: 'fa fa-angle-right',
          permissionRequired: 'pm.orders.view'
        },
        {
          name: 'On Hold',
          url: '/orders?orderStatus=on_hold',
          icon: 'fa fa-angle-right',
          permissionRequired: 'pm.orders.view'
        },
        {
          name: 'Awaiting Shipment',
          url: '/orders?orderStatus=awaiting_shipment',
          icon: 'fa fa-angle-right',
          permissionRequired: 'pm.orders.view'
        },
        {
          name: 'Pending Fulfillment',
          url: '/orders?orderStatus=pending_fulfillment',
          icon: 'fa fa-angle-right',
          permissionRequired: 'pm.orders.view'
        },
        {
          name: 'Shipped',
          url: '/orders?orderStatus=shipped&quickView=true',
          icon: 'fa fa-angle-right',
          permissionRequired: 'pm.orders.view'
        },
        {
          name: 'Cancelled',
          url: '/orders?orderStatus=cancelled',
          icon: 'fa fa-angle-right',
          permissionRequired: 'pm.orders.view'
        }
      ]
    },
    {
      name: 'Fulfillment',
      url: '/fulfillment/storefront-orders',
      icon: 'fa fa-cube',
      permissionRequired: 'pm.orders.fulfill',
      children: [
        {
          name: 'Storefront Orders',
          url: '/fulfillment/storefront-orders',
          icon: 'fa fa-angle-right',
          permissionRequired: 'pm.orders.fulfill'
        },
        {
          name: 'Shipment Labels',
          url: '/fulfillment/labels',
          icon: 'fa fa-angle-right',
          permissionRequired: 'pm.orders.fulfill'
        },
        {
          name: 'Batches',
          url: '/fulfillment/batches',
          icon: 'fa fa-angle-right',
          permissionRequired: 'pm.orders.fulfill'
        },
        {
          name: 'Configure Boxes',
          url: '/fulfillment/brand-fulfillment-boxes',
          icon: 'fa fa-angle-right',
          permissionRequired: 'pm.fulfillment.brandFulfillmentBoxes'
        },
      ]
    },
    {
      name: 'Reports',
      url: '/reports',
      icon: 'icon-calculator',
      permissionRequired: 'pm.reports.storefrontProdStats',
      children: [
        {
          name: 'Storefront Inv. Stats',
          url: '/report/storefront-stats',
          icon: 'fa fa-angle-right',
          permissionRequired: 'pm.reports.storefrontProdStats'
        },
        {
          name: 'Orders Fulfillment',
          url: '/reports/generatedReports/OrderFulfillmentsReport',
          icon: 'fa fa-angle-right',
          permissionRequired: 'pm.reports.orderFulfillment'
        },
        {
          name: 'Shipped Count',
          url: '/reports/generatedReports/StorefrontShippedCount',
          icon: 'fa fa-angle-right',
          permissionRequired: 'pm.reports.shippedCount'
        },
        {
          name: 'Reships by Month',
          url: '/reports/generatedReports/StorefrontReshipReportByMonth',
          icon: 'fa fa-angle-right',
          permissionRequired: 'pm.reports.shippedCount'
        },
        {
          name: 'Ordered Items Report',
          url: '/reports/generatedReports/OrderedWarehouseItemsReport',
          icon: 'fa fa-angle-right',
          permissionRequired: 'pm.reports.orderedItems'
        },
        {
          name: 'Warehouse Trans. Summary',
          url: '/reports/generatedReports/WarehouseItemsInOutReport',
          icon: 'fa fa-angle-right',
          permissionRequired: 'pm.reports.wareTransSummary'
        },
        {
          name: 'Factoring Report',
          url: '/reports/generatedReports/FactoringFinanceInvoiceReport',
          icon: 'fa fa-angle-right',
          permissionRequired: 'pm.billing.factoringLedger'
        },
        {
          name: 'Historical Inventory Report',
          url: '/reports/generatedReports/HistoricalInventoryReport',
          icon: 'fa fa-angle-right',
          permissionRequired: 'pm.reports.wareTransSummary'
        },
        {
          name: 'Items On Backorder',
          url: '/reports/generatedReports/ReportItemsOnBackorder',
          icon: 'fa fa-angle-right',
          permissionRequired: 'pm.reports.wareTransSummary'
        },
        {
          name: 'Client Billing: By Order Margin',
          url: '/reports/generatedReports/ReportFinanceMargin',
          icon: 'fa fa-angle-right',
          permissionRequired: 'pm.orders.view.financeMargin'
        },
        {
          name: 'Client Billing: Margin Summary',
          url: '/reports/generatedReports/ReportFinanceMarginSummary',
          icon: 'fa fa-angle-right',
          permissionRequired: 'pm.orders.view.financeMargin'
        }
      ]
    },
    {
      name: 'Warehouses',
      url: '/warehouses',
      icon: 'fa fa-building',
      permissionRequired: 'pm.warehouses.items.view',
      children: [
        {
          name: 'Manage',
          url: '/warehouses/manage',
          icon: 'fa fa-angle-right',
          permissionRequired: 'pm.warehouses.view'
        },
        {
          name: 'Inventory',
          url: '/warehouses/items',
          icon: 'fa fa-angle-right',
          permissionRequired: 'pm.warehouses.items.view'
        },
        {
          name: 'Inv. Snapshots',
          url: '/inventory/snapshots',
          icon: 'fa fa-angle-right',
          permissionRequired: 'pm.warehouses.items.viewInventoryByLocation'
        },
        {
          name: '4PL Inv. Not in Sync',
          url: '/warehouses/items-with-some-offset',
          icon: 'fa fa-angle-right',
          permissionRequired: 'pm.warehouses.items.view'
        }
      ]
    },
    {
      name: 'Manage Inventory',
      url: '/inventory',
      icon: 'fa fa-truck',
      permissionRequired: 'pm.warehouses.items.viewInventoryByLocation',
      children: [
        {
          name: 'Warehouse Transfers',
          url: '/inventory/warehouseTransfers',
          icon: 'fa fa-angle-right',
          permissionRequired: 'pm.warehouses.wt.view'
        },
        {
          name: 'Advanced Ship Notices',
          url: '/inventory/advancedShipNotice',
          icon: 'fa fa-angle-right',
          permissionRequired: 'pm.warehouses.asn.view'
        },
        {
          name: 'Purchase Orders',
          url: '/inventory/purchaseOrders',
          icon: 'fa fa-angle-right',
          permissionRequired: 'pm.warehouses.purchaseOrders.view'
        },
        {
          name: 'Adjustments',
          url: '/inventory/adjustments',
          icon: 'fa fa-angle-right',
          permissionRequired: 'pm.warehouses.diu.view'
        },
        {
          name: 'Inv. By Location',
          url: '/inventory/itemsByLocation',
          icon: 'fa fa-angle-right',
          permissionRequired: 'pm.warehouses.items.viewInventoryByLocation'
        },
        {
          name: 'Other Small Parcel (depr.)',
          url: '/inventory/manual-shipments',
          icon: 'fa fa-angle-right',
          permissionRequired: 'pm.warehouses.smallparcels.view'
        },
        {
          name: 'Bulk Shipments',
          url: '/inventory/bulkShipments',
          icon: 'fa fa-angle-right',
          permissionRequired: 'pm.warehouses.bulkShipments.view'
        }
      ]
    },
    {
      name: 'Manufacturing',
      url: '/manufacturing',
      icon: 'fa fa-industry',
      permissionRequired: 'pm.manufacturing.workOrders.view',
      children: [
        {
          url: '/manufacturing/work-orders',
          name: 'Work Orders',
          icon: 'fa fa-angle-right',
          permissionRequired: 'pm.manufacturing.workOrders.view'
        },
        {
          url: '/manufacturing/billOfMaterials',
          name: 'Bills of Materials',
          icon: 'fa fa-angle-right',
          permissionRequired: 'pm.manufacturing.billOfMaterials.view'
        },
        {
          url: '/manufacturing/RnD/projects',
          name: 'R&D Projects',
          icon: 'fa fa-angle-right',
          permissionRequired: 'pm.manufacturing.rndProjects.view'
        },
        {
          name: 'Vendors',
          url: '/manufacturing/vendors',
          icon: 'fa fa-angle-right',
          permissionRequired: 'pm.manufacturing.vendors.view'
        }
      ]
    },
    {
      name: 'Integrations',
      url: '/integrations',
      permissionRequired: 'pm.integrations.extensiv.facilities',
      icon: 'fa fa-usb',
      children: [
        {
          name: 'Order Source Integrations',
          url: '/integrations/order-source-integrations',
          icon: 'fa fa-angle-right',
          permissionRequired: 'pm.integrations.orderSourceIntegrations.view'
        },
        {
          name: 'Third Party Apps',
          url: '/integrations/third-party-apps',
          icon: 'fa fa-angle-right',
          permissionRequired: 'pm.integrations.orderSourceIntegrations.view'
        },
        {
          name: 'Extensiv',
          url: '/integrations/tpl',
          icon: 'fa fa-angle-right',
          children: [
            {
              name: 'Facilities',
              url: '/integrations/tpl/facilities',
              icon: 'fa fa-angle-right',
              permissionRequired: 'pm.integrations.extensiv.facilities'
            },
            {
              name: 'Customers',
              url: '/integrations/tpl/customers',
              icon: 'fa fa-angle-right',
              permissionRequired: 'pm.integrations.extensiv.customers'
            },
            {
              name: 'Adjustments',
              url: '/integrations/tpl/adjustments',
              icon: 'fa fa-angle-right',
              permissionRequired: 'pm.integrations.extensiv.adjustments'
            },
            {
              name: 'Shipment Services',
              url: '/integrations/tpl/shipment-services',
              icon: 'fa fa-angle-right',
              permissionRequired: 'pm.integrations.extensiv.carrierServices'
            },
            {
              name: 'Billing Codes',
              url: '/integrations/tpl/billing-codes',
              icon: 'fa fa-angle-right',
              permissionRequired: 'pm.integrations.extensiv.billingCodes'
            },
            {
              name: 'Receipts (ASNs)',
              url: '/integrations/tpl/receivers',
              icon: 'fa fa-angle-right',
              permissionRequired: 'pm.integrations.extensiv.receipts'
            },
            // {
            //   name: 'Customer Orders',
            //   url: '/integrations/tpl/customer-orders',
            //   icon: 'fa fa-angle-right',
            //  permissionRequired: 'pm.integrations.extensiv.customerOrders'
            // },
            // {
            //   name: 'Purchase Orders',
            //   url: '/integrations/tpl/purchase-orders',
            //   icon: 'fa fa-angle-right'
            // },
            {
              name: 'UOM',
              url: '/integrations/tpl/uom',
              icon: 'fa fa-angle-right',
              permissionRequired: 'pm.integrations.carrierConfig'
            }
          ]
        },
        {
          name: 'Carrier Integrations',
          url: '/manage/integration-carriers',
          icon: 'fa fa-angle-right',
          permissionRequired: 'pm.integrations.extensiv.carriers'
        },
        {
          name: 'Import Sheet Mappings',
          url: '/inventory/import-sheet-mapping-methods',
          icon: 'fa fa-angle-right',
          permissionRequired: 'pm.warehouses.items.view'
        },
        {
          name: 'API Access',
          url: '/integrations/api-access',
          icon: 'fa fa-angle-right',
          permissionRequired: 'pm.api.apikeys.manage'
        }
      ]
    },
    {
      name: 'User Directory',
      url: '/profiles/list',
      icon: 'fa fa-vcard'
    },
    {
      name: 'Analytics',
      url: '/analytics',
      icon: 'fa fa-line-chart',
      permissionRequired: 'pm.analytics.parcelShipments',
      children: [
        {
          name: 'Parcels Shipped Stats',
          url: '/analytics/parcel-shipments',
          icon: 'fa fa-angle-right',
          permissionRequired: 'pm.analytics.parcelShipments',
        },
        {
          name: 'Order Fulfillment Stats',
          url: '/analytics/order-fulfillment-stats',
          icon: 'fa fa-angle-right',
          permissionRequired: 'pm.analytics.fulfillmentStats',
        },
        {
          name: 'Client Billing Stats',
          url: '/analytics/billing-charge-stats',
          icon: 'fa fa-angle-right',
          permissionRequired: 'pm.analytics.clientBillingStats',
        },
        {
          name: 'Carrier Billing Stats',
          url: '/analytics/carrier-billing-charge-stats',
          icon: 'fa fa-angle-right',
          permissionRequired: 'pm.analytics.carrierBillingStats',
        },
        {
          name: 'Surcharge Breakdown',
          url: '/analytics/surcharge-breakdown',
          icon: 'fa fa-angle-right',
          permissionRequired: 'pm.analytics.clientBillingStats',
        },
      ],
    },
    {
      name: 'Billing',
      url: '/finance/billing',
      icon: 'fa fa-dollar mr-2',
      permissionRequired: 'pm.customerBilling.invoices.view',
      children: [
        {
          name: 'Alert Center',
          url: '/manage/billing/alertCenter',
          icon: 'fa fa-angle-right',
          permissionRequired: 'pm.customerBilling.billingEntries'
        },
        {
          name: 'Rate Cards',
          url: '/manage/billing/rateCards',
          icon: 'fa fa-angle-right',
          permissionRequired: 'pm.customerBilling.rateCards'
        },
        {
          name: 'Client: Invoices',
          url: '/manage/billing/customerInvoices',
          icon: 'fa fa-angle-right',
          permissionRequired: 'pm.customerBilling.invoices.view'
        },
        {
          name: 'Client: Billing Entries',
          url: '/manage/billing/customerBilingLedger',
          icon: 'fa fa-angle-right',
          permissionRequired: 'pm.customerBilling.billingEntries'
        },
        {
          name: 'Carrier: Invoices',
          url: '/manage/billing/carrierInvoices',
          icon: 'fa fa-angle-right',
          permissionRequired: 'pm.carrierBilling.invoices'
        },
        {
          name: 'Carrier: Charges',
          url: '/manage/billing/carrierBillingEntries',
          icon: 'fa fa-angle-right',
          permissionRequired: 'pm.carrierBilling.billingEntries'
        },
        {
          name: 'Carrier: Charge Classifications',
          url: '/manage/billing/carrierInvoiceChargeConfigurations',
          icon: 'fa fa-angle-right',
          permissionRequired: 'pm.carrierBilling.billingEntries'
        },
        {
          name: 'Zone Lookup Mappings',
          url: '/manage/billing/zone-lookup-config',
          icon: 'fa fa-angle-right',
          permissionRequired: 'pm.carrierBilling.billingEntries'
        },
        {
          name: 'Currency Conversion Rates',
          url: '/manage/billing/conversionRateHistoricalRecords',
          icon: 'fa fa-angle-right',
          permissionRequired: 'pm.carrierBilling.billingEntries'
        }
      ]
    },
    {
      name: 'Support',
      url: '/support/new-tickets',
      icon: 'fa fa-ticket',
      permissionRequired: 'pm.support.tickets.create'
    },
    {
      name: 'Configure',
      url: '/other',
      icon: 'fa fa-cogs',
      permissionRequired: 'pm.other.skuMaintenance',
      children: [
        {
          name: 'Manage Users',
          url: '/admin/users',
          icon: 'icon-user',
          permissionRequired: 'pm.users.manage.view'
        },
        {
          name: 'Config: Carriers',
          url: '/admin/carriers',
          icon: 'fa fa-angle-right',
          permissionRequired: 'pm.integrations.extensiv.carriers'
        },
        {
          name: 'Carrier Services',
          url: '/admin/carrier-services',
          icon: 'fa fa-angle-right',
          permissionRequired: 'pm.integrations.extensiv.carriers'
        },
        {
          name: 'Logs',
          url: '/other/logs',
          icon: 'fa fa-fax',
          children: [
            {
              name: 'System Log',
              url: '/other/logs/system',
              icon: 'fa fa-angle-right',
              permissionRequired: 'pm.other.systemLogs'
            },
            {
              name: 'User Log',
              url: '/other/logs/users',
              icon: 'fa fa-angle-right',
              permissionRequired: 'pm.other.userLogs'
            }
          ]
        },
        {
          name: 'SKU Maintenance',
          url: '/skuMaintenance',
          icon: 'fa fa-usb mr-2',
          permissionRequired: 'pm.other.skuMaintenance'
        },
        {
          name: 'Changelog',
          url: '/docs/changelog',
          icon: 'fa fa-book mr-2',
          permissionRequired: 'pm.knowledgebase.view'
        },
        {
          name: 'Automation',
          url: '/other/automation',
          icon: 'fa fa-fax mr-2',
          children: [
            {
              name: 'Automation Config',
              url: '/other/automation',
              icon: 'fa fa-angle-right',
              permissionRequired: 'pm.automation.triggers'
            },
            {
              name: 'Content Templates',
              url: '/other/automation/content-templates',
              icon: 'fa fa-angle-right',
              permissionRequired: 'pm.automation.contentTemplates'
            },
            {
              name: 'Automations Log',
              url: '/other/automation/log',
              icon: 'fa fa-angle-right',
              permissionRequired: 'pm.automation.log'
            }
          ]
        }
      ]
    },
  ]
};
